import React, { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import { useSelector } from "react-redux";

const MarketGraph = ({ tableData }) => {
  // const newLabels = tableData?.map((t) => {
  //     return t.tokenOutstanding;
  //   });
  const [labels, setLabels] = useState([]);

  useEffect(() => {
    console.log({ tableData });

    const newLabels = tableData?.map((t) => {
      return t.tokenOutstanding;
    });
    const campNames = tableData?.map((t) => {
      return t.campaignId.campaignName;
    });
    console.log({ newLabels });
    setLabels(campNames);
    setSeries(newLabels);
    setOptions({ ...options, labels: labels });
  }, [tableData]);

  const [series, setSeries] = useState([]);

  //   const marketGraph = useSelector((state) => state.web3.data.marketGraph);

  //   console.log("marketGraph => ", marketGraph);

  const [options, setOptions] = useState({
    chart: {
      type: "polarArea",
    },
    stroke: {
      colors: ["#fff"],
    },
    fill: {
      opacity: 0.9,
    },
    dataLabels: {
      enabled: false,
      enabledOnSeries: false,
    },
    legend: {
      // show:false
    },
    markers: {
      show: false,
    },

    labels: ["Apples", "Oranges", "Berries", "Grapes"],
    // "Apples", "Oranges", "Berries", "Grapes"],
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: 400,
          },
          legend: {
            position: "bottom",
          },
        },
      },
    ],
  });

  //   useEffect(() => {
  //     if (marketGraph?.prices.length > 0) {
  //       let timeStampArray = marketGraph?.prices.map((item) => item[0]);
  //       let priceArray = marketGraph?.prices.map((item) => item[1]);

  //       console.log("graph arrays => ", { timeStampArray, priceArray });
  //       setSeries([
  //         {
  //          tableData?.map((t) => {

  //       ]);

  //       setOptions({
  //         ...options,

  //         xaxis: {
  //           type: "datetime",
  //           categories: timeStampArray,
  //           show: timeStampArray > 0,
  //         },

  //         yaxis: {
  //           show: priceArray.length > 0,
  //           decimalsInFloat: 6,
  //         },

  //         grid: {
  //           show: priceArray.length > 0,
  //         },
  //       });
  //     }
  //   }, [marketGraph]);
  return (
    <Chart options={options} series={series} type="polarArea" height={450} />
  );
};

export default MarketGraph;
